import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { IndustryModel } from '../../models/resources/industry.model';
import { LanguageService } from './language.service';
import { UrlParamModel } from '../../models/url-param.model';

@Injectable({
  providedIn: 'root',
})
export class IndustryService extends AResourceService<IndustryModel> {
  constructor(private languageService: LanguageService) {
    super('/industries', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{ key: 'lang', value: code }];
  }
}
